/** Middle/platform ответ: auxiliary core уже уничтожен (document transition, srvCnt=0). */
export function isPlatformCoreNullError(error: unknown): boolean {
  const err = error as {
    response?: { data?: { message?: string; developerMessage?: string } }
    message?: string
  }
  const text = [
    err?.response?.data?.message,
    err?.response?.data?.developerMessage,
    err?.message,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()
  return (
    text.includes('core is null') ||
    text.includes('core cannot be null') ||
    /"core"\s+is\s+null/.test(text)
  )
}
